<template>
  <div style="height:50px;">
    <van-tabbar route :active-color="$abctheme.basecolor">
       <!-- <van-tabbar-item  to="/retailindex">
          <template>
            <img src="../../assets/images/firstlogo.png" style="width:40px;height:40px;" />
          </template>
       </van-tabbar-item>

      <van-tabbar-item icon="apps-o" to="/retailpage">
         全部商品
      </van-tabbar-item>
      
      <van-tabbar-item icon="cart" to="/retailcart">购物车</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/retailuser">我的</van-tabbar-item> 
      -->
      <van-tabbar-item icon="wap-home" to="/retailpage">首页</van-tabbar-item>
     <!-- <van-tabbar-item  to="/retailpage">
          <template>
            <img src="../../assets/images/qyhlogo.jpg" style="width:40px;height:40px;" />
          </template>
      </van-tabbar-item> -->
      <van-tabbar-item icon="coupon-o" to="/retailcoupon">活动专区</van-tabbar-item>
      <van-tabbar-item icon="comment" @click="noto">育儿</van-tabbar-item>

      <!-- <van-tabbar-item icon="comment" to="/communityindex">育儿</van-tabbar-item> -->

       <!-- <van-tabbar-item icon="apps-o" to="/integralpage">积分商品</van-tabbar-item> -->
      <van-tabbar-item icon="cart" to="/retailcart">购物车</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/retailuser">我的</van-tabbar-item>

    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  name: "retailfooter",
  data() {
    return {
      logoimg:''
    };
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  methods: {
    noto(){
      this.$dialog.alert({
        title:'功能建设中,敬请期待~'
      })
    }
  },
};
</script>

